import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-12 sm:py-20 bg-[#0D2B4E] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/2 translate-y-1/2" />
      </div>
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-2 mb-5">
            <div className="w-2 h-2 bg-yellow-400 rounded-full" />
            <span className="text-white/90 text-sm font-medium">Kostenlose Beratung</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
            Ihr Bauprojekt in guten Händen
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-white/80 mb-6 sm:mb-10 leading-relaxed px-4">
            Schildern Sie uns Ihr Vorhaben – ob Neubau, Sanierung oder Renovierung. Wir erstellen
            Ihnen kostenlos ein unverbindliches Festpreisangebot.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center gap-2 bg-white text-[#0D2B4E] px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-file-text-line text-xl" />
              </div>
              <span>Kostenlos anfragen</span>
            </Link>
            <a
              href="tel:+492102739807"
              className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/30 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-phone-line text-xl" />
              </div>
              <span>02102 / 7398070</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
